(function() { window.GUID_d642dab2_bfff_49e1_b6dd_a7b766b0c492 = { getGuid: function() { return "d642dab2-bfff-49e1-b6dd-a7b766b0c492"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PromotionTypeId;
        (function (PromotionTypeId) {
            PromotionTypeId[PromotionTypeId["FreeTrial"] = 1] = "FreeTrial";
        })(PromotionTypeId = Enumeration.PromotionTypeId || (Enumeration.PromotionTypeId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PromotionTypeId.pre.js.map
